module.exports = __webpack_public_path__ + "static/img/PhiniaLogo.d3aa4e82.png";